import { useCallback, useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { toast } from 'sonner';

export const errMsg = (e) => e?.response?.data?.detail || e?.message || 'Error';

export const STATUS_TONE = {
  accepted_dian: 'text-emerald-700 bg-emerald-50 border-emerald-200',
  completed: 'text-emerald-700 bg-emerald-50 border-emerald-200',
  ok: 'text-emerald-700 bg-emerald-50 border-emerald-200',
  draft: 'text-slate-700 bg-slate-50 border-slate-200',
  sent_to_factus: 'text-blue-700 bg-blue-50 border-blue-200',
  running: 'text-blue-700 bg-blue-50 border-blue-200',
  blocked_missing_doc: 'text-amber-800 bg-amber-50 border-amber-200',
  blocked_quota_exceeded: 'text-amber-800 bg-amber-50 border-amber-200',
  blocked_parent_rejected: 'text-amber-800 bg-amber-50 border-amber-200',
  completed_with_errors: 'text-amber-800 bg-amber-50 border-amber-200',
  blocked_invalid: 'text-rose-800 bg-rose-50 border-rose-200',
  failed_max_retries: 'text-rose-800 bg-rose-50 border-rose-200',
  rejected_dian: 'text-rose-800 bg-rose-50 border-rose-200',
  failed: 'text-rose-800 bg-rose-50 border-rose-200',
  error: 'text-rose-800 bg-rose-50 border-rose-200',
};

export function Pill({ value, testId }) {
  const tone = STATUS_TONE[value] || 'text-slate-600 bg-slate-50 border-slate-200';
  return (
    <span data-testid={testId}
      className={`inline-block text-[10px] font-bold uppercase tracking-wider border px-2 py-0.5 ${tone}`}>
      {value || '—'}
    </span>
  );
}

export function Empty({ children, testId }) {
  return (
    <div data-testid={testId} className="border border-dashed border-slate-200 p-6 text-sm text-slate-500 text-center">
      {children}
    </div>
  );
}

export function useFetch(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const load = useCallback(async () => {
    setLoading(true);
    try { setData((await api.get(path)).data); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setLoading(false); }
  }, [path]);
  useEffect(() => { load(); }, [load]);
  return { data, loading, load };
}

export async function runAction(fn, okMsg, after) {
  try {
    const r = await fn();
    toast.success(okMsg);
    after && after();
    return r?.data;
  } catch (e) { toast.error(errMsg(e)); return null; }
}
